import { Link } from 'react-router-dom';
import { useDishes } from '../hooks/useDishes';
import DishCard from '../components/DishCard';
import Spinner from '../components/Spinner';
import EmptyState from '../components/EmptyState';
import emptyMenuImage from '../assets/empty-menu.png';
import { primaryButtonStyle, mintButtonStyle, lavenderButtonStyle } from '../lib/theme';

export default function DishLibrary() {
  const { dishes, loading, archiveDish } = useDishes();

  if (loading) return <Spinner label="Loading dishes…" />;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h2>Menu</h2>
        <Link to="/dishes/new">
          <button style={primaryButtonStyle}>+ Add dish</button>
        </Link>
      </div>
      {dishes.length === 0 ? (
        <EmptyState image={emptyMenuImage} alt="No dishes yet" />
      ) : (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {dishes.map((dish) => (
          <DishCard
            key={dish.id}
            dish={dish}
            actions={
              <>
                <Link to={`/dishes/${dish.id}/edit`}>
                  <button style={lavenderButtonStyle}>Edit</button>
                </Link>
                <button style={mintButtonStyle} onClick={() => archiveDish(dish.id)}>
                  Archive
                </button>
              </>
            }
          />
        ))}
      </div>
      )}
    </div>
  );
}
